import { useFormik } from 'formik';
import React, { useState, useRef, useEffect } from 'react'
import { Form, Modal } from 'react-bootstrap';
import SingleSelect from '../../../component/input_filed/SingleSelect';
import Text from '../../../component/input_filed/Text';
import DatePicker from '../../../component/input_filed/DatePicker';
import moment from 'moment/moment';
import { GoogleMap, useJsApiLoader, StandaloneSearchBox, Marker } from '@react-google-maps/api';
import File from '../../../component/input_filed/File';
import SaveButton from '../../../component/buttons/SaveButton';
import PerfectScrollbar from 'react-perfect-scrollbar'
import 'react-perfect-scrollbar/dist/css/styles.css';
import Swal from 'sweetalert2'
import { debounce } from 'lodash';
import { VehicleListRes, VehicleListTodo } from '../../../redux/slices/master_slice/vehicle/VehicleList';
import { useDispatch, useSelector } from 'react-redux';
import { VehicleSchema } from './ValidationSchema'
import { UpdateVendorVehicleRes, UpdateVendorVehicleTodo } from '../../../redux/slices/user managment/venders/AddVendorVehicle';
import { toast, ToastContainer } from 'react-toastify';
import Loader from '../../../component/loader/Loader';
import MultiFiles from '../../../component/input_filed/MultiFiles';
import SelectStatus from '../../../component/input_filed/SelectStatus';
import { RxCrossCircled } from 'react-icons/rx';
import { Tooltip } from 'react-tooltip';
import { VehicleImgDeleteRes, VehicleImgDeleteTodo } from '../../../redux/slices/user managment/venders/DeleteVehicleImg';
import { VenderVehicleDetailsRes, VenderVehicleDetailsTodo } from '../../../redux/slices/user managment/venders/VendorVehicleDetails';

const containerStyle = {
    width: '100%',
    height: '300px'
};

export default function UpdateVendorVehicle(props) {
    const { vehicle1, setVehicle1, vendorId, vehicleID, bool, setBool } = props;
    const handleClose = () => setVehicle1(false);

    const [vendorLoading, setVendorLoading] = useState(false)
    const dispatch = useDispatch()
    const vehicleList = useSelector(state => state?.VehicleList?.data?.data)
    const vehicleData = useSelector(state => state?.VendorVehicleDet?.data?.data?.[0])
    const [loading, setLoading] = useState(false)
    const [loading1, setLoading1] = useState(false)

    // console.log("vehicleID", vehicleID)

    // --------------------------MAP LOCATION CODE ---------------------------------------------------------------

    const [map, setMap] = useState(null)

    const inputRef = useRef()

    const { isLoaded } = useJsApiLoader({
        id: 'google-map-script',
        googleMapsApiKey: process.env.REACT_APP_GOOGLE_MAP_KEY,
        libraries: ['places']
    })

    const [markerPosition, setMarkerPosition] = useState(
        {
            lat: 22.720,
            lng: 75.859
        });

    const onLoad = (map) => {
        map.setCenter(markerPosition);
        map.setZoom(14);
        setMap(map)
    }

    const onUnmount = (map) => {
        setMap(null)
    }

    const handlePlaceChanged = () => {
        const [place] = inputRef.current.getPlaces();
        setMarkerPosition({ lat: place && place.geometry && place.geometry.location && place.geometry.location.lat(), lng: place && place.geometry && place.geometry.location && place.geometry.location.lng() });
        map.setCenter({ lat: place && place.geometry && place.geometry.location && place.geometry.location.lat(), lng: place && place.geometry && place.geometry.location && place.geometry.location.lng() });
        map.setZoom(14);
        setMap(map)
        setFieldValue('latitude', place && place.geometry && place.geometry.location && place.geometry.location.lat())
        setFieldValue('longitude', place && place.geometry && place.geometry.location && place.geometry.location.lng())
    }

    const handleMarkerDragged = newPosition => {
        setMarkerPosition(({ lat: newPosition.latLng?.lat(), lng: newPosition.latLng?.lng() }));
        setFieldValue('latitude', newPosition.latLng?.lat())
        setFieldValue('longitude', newPosition.latLng?.lng())
    };


    // ------------------------------------------------------------------------------------------------------------

    const vehicle_opt = vehicleList && vehicleList.map(val => (
        { "value": val.id, "label": val.vehicle_name, 'category': val.vehicle_category_id }
    ))



    const delivery_option = [
        { "value": 'pickup', "label": "Self Pickup" },
        { "value": 'delivery', "label": "Delivery" },
        { "value": 'both', "label": "Both" }
    ]

    const load_vehicle = debounce((e) => {
        if (e) {
            setVendorLoading(true)
            dispatch(VehicleListTodo(e)).then(() => vehicle_res())
        }
    }, 500)
    const vehicle_res = () => {
        if (VehicleListRes?.success) {
            setLoading1(false)
            setVendorLoading(false)
        } else {
            setLoading1(false)
            setVendorLoading(false)
        }
    }

    const initialValues = {
        model: vehicleData?.fk_vehicle_master_id || '',
        category: vehicleData?.VehicleMasterSchema?.vehicle_category_id || '',
        reg_number: vehicleData?.registration_num || "",
        reg_date: vehicleData?.registration_year || "",
        delivery_type: vehicleData?.vehicle_delivery_type || '',
        vehicle_img: vehicleData?.VendorVehiclePhotos || [],
        vehicle_video: vehicleData?.vehicle_video || '',
        rc_doc: vehicleData?.vehicle_rc_document || '',
        vehicle_doc: vehicleData?.vehicle_document || '',
        insurance_doc: vehicleData?.vehicle_insurance_document || '',
        latitude: vehicleData?.vehicle_latitude || '22.7534141',
        longitude: vehicleData?.vehicle_longitude || "75.8972057",
        status: vehicleData?.vehicle_status || '',
    }

    const { values, errors, touched, handleBlur, handleChange, handleSubmit, setFieldValue } = useFormik({
        initialValues: initialValues,
        validationSchema: VehicleSchema,
        enableReinitialize: true,

        onSubmit: (values, action) => {
            setLoading(true)
            dispatch(UpdateVendorVehicleTodo(bodyFormData)).then(() => add_res(action))
        }
    })

    let bodyFormData = new FormData();
    bodyFormData.append("fk_vendor_details_id", vendorId?.id)
    bodyFormData.append("fk_ven_vehicle_id", vehicleData?.id)
    bodyFormData.append("user_id", localStorage.getItem('user_id'))
    bodyFormData.append("fk_user_id", vendorId?.fk_user_id)
    bodyFormData.append("fk_vehicle_master_id", values.model)
    bodyFormData.append("category_id", values.category)
    bodyFormData.append("registration_num", values.reg_number)
    bodyFormData.append("registration_year", values.reg_date)
    bodyFormData.append("vehicle_delivery_type", values.delivery_type)
    bodyFormData.append("vehicle_document", values.vehicle_doc)
    for (var i = 0; i < values.vehicle_img.length; i++) {
        var file = values.vehicle_img[i].file;
        bodyFormData.append('vehicle_photos', file);
    }
    bodyFormData.append("vehicle_vedio", values.vehicle_video)
    bodyFormData.append("vehicle_latitude", values.latitude)
    bodyFormData.append("vehicle_longitude", values.longitude)
    bodyFormData.append("vehicle_insurance_document", values.insurance_doc)
    bodyFormData.append("vehicle_rc_document", values.rc_doc)
    bodyFormData.append("vehicle_status", values.status)


    const add_res = (action) => {
        if (UpdateVendorVehicleRes?.success) {
            setLoading(false)
            setBool(!bool)
            toast.success(UpdateVendorVehicleRes?.message, { position: "bottom-right" });
            setVehicle1(false)

        } else {
            action.resetForm()
            setLoading(false)
            toast.error(UpdateVendorVehicleRes?.message, { position: "bottom-right" });
        }
    }

    const handleImgDelete = (data) => {
        Swal.fire({
            title: "Vehicle Image Delete",
            text: "Are You Sure Want To Delete This Image ?",
            icon: 'question',
            showCancelButton: true,
            confirmButtonColor: '#121136',
            cancelButtonColor: '#EF3D50',
            cancelButtonText: 'Cancel',
            confirmButtonText: 'Delete'
        }).then((result) => {
            if (result.isConfirmed) {
                dispatch(VehicleImgDeleteTodo(data.id)).then(() => del_res())
            }
        })

    }
    const del_res = () => {
        if (VehicleImgDeleteRes?.success) {
            setBool(!bool)
            Swal.fire(
                "Image",
                'Image Deleted Successfully',
                'success'
            )
        } else {
            toast.error(VehicleImgDeleteRes?.message, { position: "bottom-right" })
        }
    }

    useEffect(() => {
        setLoading1(true)
        dispatch(VenderVehicleDetailsTodo(vehicleID)).then(() => details_res())
    }, [vehicleID,bool])

    const details_res = () => {
        if (VenderVehicleDetailsRes?.success) {
            dispatch(VehicleListTodo(vehicleData?.vehicle_name)).then(() => vehicle_res())
        } else {
            setLoading1(false)
        }
    }


    return (
        <>
            <Modal show={vehicle1} onHide={handleClose} size="xl" aria-labelledby="example-modal-sizes-title-xl">
                <Modal.Header closeButton>
                    <Modal.Title id="example-modal-sizes-title-xl">Update Vehicle</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <PerfectScrollbar style={{ height: '75vh' }}>
                        {loading || loading1 ?
                            <div className='d-flex justify-content-center mt-5 pb-5'>
                                <Loader />
                            </div> :

                            <div className='p-3'>
                                <Form onSubmit={(e) => { e.preventDefault(); handleSubmit(); }}>

                                    <div className="row">
                                        <div className="col-md-4">
                                            <SingleSelect
                                                closeMenu={true}
                                                // placeholder={'Vehicle'}
                                                // reference={selectVendRef}
                                                label_name={"Model"}
                                                option={vehicle_opt}
                                                required={true}
                                                disabled={false}
                                                name='model'
                                                defaultValue={vehicle_opt && vehicle_opt.find((option) => option.value === values.model)}
                                                onChange={(e) => {
                                                    setFieldValue('model', e?.value)
                                                    setFieldValue('category', e?.category)
                                                }
                                                }
                                                loading={vendorLoading}
                                                onInputChange={(e) => load_vehicle(e)}
                                                onBlur={handleBlur}
                                                error={errors.model && touched.model ? (<span className='text-danger form_label' >{errors.model}</span>) : null}
                                            />
                                        </div>
                                        <div className="col-md-4">
                                            <Text
                                                label_name='Registration No.'
                                                placeholder=''
                                                required={true}
                                                name='reg_number'
                                                value={values.reg_number || ''}
                                                onChange={handleChange}
                                                onBlur={handleBlur}
                                                error={errors.reg_number && touched.reg_number ? (<span className='text-danger form_label' >{errors.reg_number}</span>) : null}
                                            />
                                        </div>
                                        <div className="col-md-4">
                                            <DatePicker
                                                label_name='Registration Date'
                                                placeholder={''}
                                                option={{
                                                    altInput: true,
                                                    altFormat: "F j, Y",
                                                    dateFormat: 'Y-m-d',
                                                    minDate: '',
                                                    maxDate: '',
                                                    disable: [],
                                                    mode: "single",
                                                    defaultDate: [],
                                                    conjunction: "",
                                                }}
                                                required={true}
                                                name='reg_date'
                                                value={values.reg_date}
                                                onChange={(e) =>
                                                    setFieldValue('reg_date', moment(e[0]).format("YYYY-MM-DD"))

                                                }
                                                onBlur={handleBlur}
                                                error={errors.reg_date && touched.reg_date ? (<span className='text-danger form_label' >{errors.reg_date}</span>) : null}
                                            />
                                        </div>
                                        <div className="col-md-4">
                                            <SingleSelect
                                                closeMenu={true}
                                                label_name='Delivery Type'
                                                option={delivery_option ? delivery_option : []}
                                                disabled={false}
                                                name='delivery_type'
                                                defaultValue={delivery_option && delivery_option.find((option) => option.value === values.delivery_type)}
                                                onChange={(e) =>
                                                    setFieldValue('delivery_type', e.value)
                                                }
                                                onBlur={handleBlur}
                                                error={''}
                                            />
                                        </div>

                                        <div className='col-md-4  '>
                                            {/* <File
                                            name='vehicle_img'
                                            required={true}
                                            label_name={'Image'}
                                            onBlur={handleBlur}
                                            onChange={(e) => setFieldValue("vehicle_img", e.currentTarget.files[0])}
                                            error={errors.vehicle_img && touched.vehicle_img ? (<span className='text-danger form_label' >{errors.vehicle_img}</span>) : null}
                                        /> */}
                                            <MultiFiles
                                                name='vehicle_img'
                                                label_name={'Vehicle Images '}
                                                onBlur={handleBlur}
                                                required={true}
                                                onChange={(e) => {
                                                    const filesArray = Array.from(e.currentTarget.files).map((file) => ({
                                                        file: file,
                                                        // You can add additional properties if needed, like file name, size, type, etc.
                                                    }));
                                                    setFieldValue('vehicle_img', filesArray)
                                                    // setFieldValue("vehicle_img", e.currentTarget.files)

                                                }}
                                                error={errors.vehicle_img && touched.vehicle_img ? (<span className='text-danger form_label' >{errors.vehicle_img}</span>) : null}
                                            />

                                        </div>
                                        <div className='col-md-4  '>
                                            <File
                                                name='vehicle_video'
                                                label_name={'Video'}
                                                onBlur={handleBlur}
                                                onChange={(e) => setFieldValue("vehicle_video", e.currentTarget.files[0])}
                                                error={''}
                                            />
                                        </div>
                                        <div className='col-md-4  '>
                                            <File
                                                name='rc_doc'
                                                label_name={'RC Document'}
                                                required={true}
                                                onBlur={handleBlur}
                                                onChange={(e) => setFieldValue("rc_doc", e.currentTarget.files[0])}
                                                error={errors.rc_doc && touched.rc_doc ? (<span className='text-danger form_label' >{errors.rc_doc}</span>) : null}
                                            />
                                        </div>
                                        <div className='col-md-4  '>
                                            <File
                                                name='insurance_doc'
                                                label_name={'Insurance Document'}
                                                onBlur={handleBlur}
                                                onChange={(e) => setFieldValue("insurance_doc", e.currentTarget.files[0])}
                                                error={""}
                                            />
                                        </div>
                                        <div className='col-md-4  '>
                                            <File
                                                name='vehicle_doc'
                                                label_name={'Vehicle Document'}
                                                onBlur={handleBlur}
                                                onChange={(e) => setFieldValue("vehicle_doc", e.currentTarget.files[0])}
                                                error={''}
                                            />
                                        </div>
                                        {/* <h6 className='text-center'>Vehicle Location</h6> */}
                                        <div className="col-md-8">
                                            {isLoaded && markerPosition ? (
                                                <GoogleMap
                                                    mapContainerStyle={containerStyle}
                                                    // center={center}
                                                    zoom={3}
                                                    onLoad={onLoad}
                                                    onUnmount={onUnmount}
                                                    onClick={handleMarkerDragged}
                                                    markerPosition={markerPosition}
                                                    onMarkerDragged={handleMarkerDragged}
                                                >
                                                    <Marker
                                                        position={markerPosition}
                                                        draggable={true}
                                                        onDragEnd={event => {
                                                            const lat = event.latLng.lat();
                                                            const lng = event.latLng.lng();
                                                            handleMarkerDragged(event);
                                                        }}
                                                    />
                                                    <StandaloneSearchBox
                                                        onLoad={ref => (inputRef.current = ref)}
                                                        onPlacesChanged={handlePlaceChanged}
                                                    >
                                                        <input
                                                            type='text'
                                                            className='from-control google_search'
                                                            placeholder='Search Location'
                                                        />
                                                    </StandaloneSearchBox>
                                                    { /* Child components, such as markers, info windows, etc. */}
                                                    <></>
                                                </GoogleMap>
                                            ) : <></>
                                            }
                                        </div>
                                        <div className="col-md-4">
                                            <div className="row">
                                                <div className="col-md-12">
                                                    <Text
                                                        label_name='Latitude'
                                                        placeholder=''
                                                        name='latitude'
                                                        value={values.latitude || ''}
                                                        onChange={handleChange}
                                                        onBlur={handleBlur}
                                                        error={errors.latitude && touched.latitude ? (<span className='text-danger form_label' >{errors.latitude}</span>) : null}
                                                    />
                                                </div>

                                                <div className="col-md-12">
                                                    <Text
                                                        label_name='Longitude'
                                                        placeholder=''
                                                        name='longitude'
                                                        value={values.longitude || ''}
                                                        onChange={handleChange}
                                                        onBlur={handleBlur}
                                                        error={errors.longitude && touched.longitude ? (<span className='text-danger form_label' >{errors.longitude}</span>) : null}
                                                    />
                                                </div>
                                                <div className='col-md-12'>
                                                    <SelectStatus
                                                        closeMenu={true}
                                                        label_name='Status'
                                                        disabled={false}
                                                        name='status'
                                                        defaultValue={values?.status}
                                                        required={true}
                                                        onChange={(e) =>
                                                            setFieldValue('status', e.value)
                                                        }
                                                        onBlur={handleBlur}
                                                        error={errors.status && touched.status ? (<span className='text-danger form_label' >{errors.status}</span>) : null}
                                                    />
                                                </div>

                                            </div>
                                        </div>
                                        <div className='col-md-12 mt-2'>
                                            <div className='row'>
                                                {/* <h5>Shop Images</h5>
                                    {vendorData?.ShopImageSchemas?.length ? */}
                                                {vehicleData?.VendorVehiclePhotos?.map(val =>
                                                    <div className='col-md-2 mt-2'>
                                                        <div className="post_img_section p-4" style={{ position: "relative" }}>
                                                            <span className='img_dele_ico' data-tooltip-id='del'
                                                                data-tooltip-content="Delete Image!"
                                                                data-tooltip-place="bottom" type='button' onClick={() => handleImgDelete(val)}><RxCrossCircled size={20} style={{ color: "red" }} /></span>
                                                            <img src={process.env.REACT_APP_IMAGE_URL + `${val.vehicle_photos_url}`} className='img-fluid post_img' alt="img" />
                                                            {/* <img src={vendorImage} className='img-fluid post_img p-3' alt="img" /> */}
                                                        </div>
                                                        <Tooltip id='del' className='bg-danger tooltip_msg' />
                                                    </div>
                                                )
                                                }
                                            </div>
                                        </div>
                                        <div className='col-md-12 text-end mt-1'>
                                            <SaveButton name={'Save'} />
                                        </div>

                                    </div>
                                </Form>
                            </div>
                        }
                    </PerfectScrollbar>
                </Modal.Body>
            </Modal>
        </>
    )
}
